/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  BridgeTollBooth,
  BridgeTollBoothInterface,
} from "../BridgeTollBooth";

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "relayFee",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "greenFee",
        type: "uint256",
      },
    ],
    name: "FeesCollected",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [],
    name: "fees",
    outputs: [
      {
        internalType: "uint256",
        name: "relayFee",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "greenFee",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "initiator",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "tollToken",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getFees",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "relayFee",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "greenFee",
            type: "uint256",
          },
        ],
        internalType: "struct BridgeTollBooth.Fees",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "totalFees",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "driver",
        type: "address",
      },
    ],
    name: "feesAllowed",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "collectedFees",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "driver",
        type: "address",
      },
    ],
    name: "collectFees",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_initiator",
        type: "address",
      },
    ],
    name: "setInitiator",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_tollToken",
        type: "address",
      },
    ],
    name: "setTollToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "relayFee",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "greenFee",
        type: "uint256",
      },
    ],
    name: "setFees",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
    ],
    name: "withdrawCollectedFees",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class BridgeTollBooth__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<BridgeTollBooth> {
    return super.deploy(overrides || {}) as Promise<BridgeTollBooth>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): BridgeTollBooth {
    return super.attach(address) as BridgeTollBooth;
  }
  connect(signer: Signer): BridgeTollBooth__factory {
    return super.connect(signer) as BridgeTollBooth__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): BridgeTollBoothInterface {
    return new utils.Interface(_abi) as BridgeTollBoothInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): BridgeTollBooth {
    return new Contract(address, _abi, signerOrProvider) as BridgeTollBooth;
  }
}
